"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var ActionsTableCell = function ActionsTableCell(_ref) {
  var tag = _ref.tag,
      onEditTag = _ref.onEditTag,
      onDeleteTag = _ref.onDeleteTag;
  return (0, _preact.h)("span", null, (0, _preact.h)(_Button.default, {
    className: "public-tag-edit-".concat(tag.id, " qa-public-tag-edit-").concat(tag.name, " qa-public-tag-edit-").concat(tag.id),
    title: "Edit",
    onClick: function onClick() {
      return onEditTag(tag);
    }
  }), (0, _preact.h)(_Button.default, {
    className: "public-tag-remove-".concat(tag.id, " qa-public-tag-remove-").concat(tag.name, " qa-public-tag-remove-").concat(tag.id),
    title: "Remove",
    variant: "warning",
    onClick: function onClick() {
      return onDeleteTag(tag);
    }
  }));
};

var _default = ActionsTableCell;
exports.default = _default;